import { NgModule } from '@angular/core';

import { AdminsSelectDialogFormComponent } from '@recruitee/user-interface';

import {
  AdminsSelectDialogComponent,
  AdminsSelectDialogData,
} from '../dialogs/admins-select-dialog/admins-select-dialog.component';

@NgModule({
  imports: [AdminsSelectDialogFormComponent],
  declarations: [AdminsSelectDialogComponent],
  exports: [AdminsSelectDialogComponent],
})
export class RtAdminSelectSharedModule {}

export { AdminsSelectDialogComponent, AdminsSelectDialogData };
